import rtuAssets from "../assets/img/icons/rtu_assets.svg";
import rtuUpdateConfig from "../assets/img/icons/rtu_update_config.svg";
import rtuDownloadConfig from "../assets/img/icons/rtu_download_config.svg";
import rtuUpdateDeployment from "../assets/img/icons/rtu_update_deployment.svg";
import rtuDownloadDeployment from "../assets/img/icons/rtu_download_deployment.svg";
import rtuSendData from "../assets/img/icons/rtu_send_data.svg";
import rtuTimeSync from "../assets/img/icons/rtu_time_sync.svg";
import rtuReboot from "../assets/img/icons/rtu_reboot.svg";
import rtuPing from "../assets/img/icons/rtu_ping.svg";

export const RTU_ICONS = {
  ASSETS: rtuAssets,
  UPDATE_CONFIG: rtuUpdateConfig,
  DOWNLOAD_CONFIG: rtuDownloadConfig,
  UPDATE_DEPLOYMENT: rtuUpdateDeployment,
  DOWNLOAD_DEPLOYMENT: rtuDownloadDeployment,
  DEBUG_LOG: rtuDownloadConfig,
  SEND_DATA: rtuSendData,
  TIME_SYNC: rtuTimeSync,
  REBOOT: rtuReboot,
  PING: rtuPing,
  INFO: rtuAssets,
};
